@if (product) {
<div class="content">
  <app-product-images-carousel
    [images]="product.images"
  ></app-product-images-carousel>
  <div class="info">
    <app-product-location [product]="product"></app-product-location>
    <h1>{{product.name}}</h1>
    <div class="shipping">
      <span>Free shipping on orders $99+</span>
    </div>
    @for (attr of product.attrs; track $index) {
    <app-product-attr-value-select
      [attr]="attr"
      [activeValue]="attrs[$index]"
      (activeValueChange)="selectAttr($index,$event)"
    ></app-product-attr-value-select>
    }
    <app-product-attr-value-select
      [attr]="product.priced_attr"
      [activeValue]="pricedAttrValue"
      (activeValueChange)="selectPricedAttr($event)"
    >
      @if (product.priced_attr.name==='Size' &&
      product.size_table.titles.length>0) {
      <app-product-size-table-button
        [data]="product.size_table"
      ></app-product-size-table-button>
      }
    </app-product-attr-value-select>
    <div class="price">
      <span class="price"
        ><span class="d">$</span>
        <span class="n">{{pricedAttrValue?.price|number}}</span>
      </span>
    </div>
    <div class="add_to_cart">
      <app-add-to-cart-button
        [product_id]="product.id"
        [product_attr_values]="attrs"
        [product_priced_attr_value]="pricedAttrValue"
      ></app-add-to-cart-button>
    </div>
    <div class="descriptions">
      <app-product-descriptions
        [descriptions]="product.descriptions"
      ></app-product-descriptions>
    </div>
  </div>
</div>

<app-product-recommended-list [no]="product.no"></app-product-recommended-list>
}
